/* Use the existing theme carousel; add explicit pause and reduced-motion state. */
(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.dv-announcement-toggle').forEach((button) => {
      if (button.dataset.ready) return;
      const carousel = button.closest('slideshow-component');
      if (!carousel || typeof carousel.pause !== 'function') return;
      button.dataset.ready = 'true';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches;
      const update = () => {
        const stop = paused || motion.matches;
        carousel.announcementBarArrowButtonWasClicked = stop;
        if (stop || document.hidden || carousel.contains(document.activeElement)) carousel.pause();
        else carousel.play();
        button.hidden = motion.matches;
        button.setAttribute('aria-label', stop ? 'Halda áfram að sýna tilboð' : 'Gera hlé á tilboðum');
        button.querySelector('[data-dv-pause]').hidden = stop;
        button.querySelector('[data-dv-play]').hidden = !stop;
      };
      button.addEventListener('click', () => { paused = !paused; update(); });
      carousel.querySelectorAll('button[name="next"], button[name="previous"]').forEach((arrow) => {
        arrow.addEventListener('click', () => { paused = true; update(); });
      });
      motion.addEventListener('change', () => { paused = motion.matches; update(); });
      document.addEventListener('visibilitychange', update);
      update();
    });
  };
  customElements.whenDefined('slideshow-component').then(() => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
